import React from "react";
import { NavLink } from "react-router-dom";
import Styles from "./styles.module.scss";
import {
    AMAZON_CTA_LABEL,
    AMAZON_URL,
    AmazonPlacement,
    BOOK_PATH,
    trackAmazonClick,
} from "Pages/Common/ReadBeforeTheyRead/book";

interface Props {
    // Sent with the Amazon click event so each page's banner is tracked separately
    placement?: AmazonPlacement;
    className?: string;
    // full: wide banner; compact: vertical card (blog sidebar);
    // mini: short horizontal strip (inside modals)
    variant?: "full" | "compact" | "mini";
    // Called when either button is clicked, e.g. to close a modal
    onLinkClick?: () => void;
}

// Promotion banner for Varshika Jain's book (homepage, About Us). Copy is taken
// from the approved book page (/read-before-they-read).
const BookPromo: React.FC<Props> = ({
    placement = "homepage_promo",
    className = "",
    variant = "full",
    onLinkClick,
}) => {
    const mini = variant === "mini";
    return (
        <section
            className={`${Styles["book-promo"]} ${variant !== "full" ? Styles[variant] : ""} ${className}`}
            aria-label="Read Before They Read">
            <div className={Styles["container"]}>
                <div className={Styles["card"]}>
                    <NavLink to={BOOK_PATH} className={Styles["cover"]} tabIndex={-1} aria-hidden="true" onClick={onLinkClick}>
                        <picture>
                            <source srcSet="/books/read-before-they-read-cover.webp" type="image/webp" />
                            <img
                                src="/books/read-before-they-read-cover.jpg"
                                alt=""
                                width={900}
                                height={1343}
                                loading="lazy"
                            />
                        </picture>
                    </NavLink>
                    <div className={Styles["content"]}>
                        <p className={Styles["eyebrow"]}>
                            {mini ? "New from Learn2Read" : "A new chapter from Learn2Read"}
                        </p>
                        <h2>Read Before They Read</h2>
                        <p className={Styles["byline"]}>
                            By Varshika Jain · Co-Founder, Learn2Read
                        </p>
                        {!mini && (
                            <p className={Styles["text"]}>
                                Before you teach your child to read, read this. A
                                calmer, clearer way into your child’s reading
                                journey—with a practical guide written for real
                                Indian homes.
                            </p>
                        )}
                        <div className={Styles["actions"]}>
                            <NavLink to={BOOK_PATH} className={Styles["primary"]} onClick={onLinkClick}>
                                Explore the book
                            </NavLink>
                            <a
                                href={AMAZON_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={Styles["secondary"]}
                                onClick={() => {
                                    trackAmazonClick(placement);
                                    onLinkClick?.();
                                }}>
                                {AMAZON_CTA_LABEL}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BookPromo;
